import { IOption } from "../types/IOption";

export const statesOfSpain: IOption[] = [
  { label: "Andalucía", value: "Andalucía" },
  { label: "Aragón", value: "Aragón" },
  { label: "Asturias", value: "Asturias" },
  { label: "Islas Baleares", value: "Islas Baleares" },
  { label: "Canarias", value: "Canarias" },
  { label: "Cantabria", value: "Cantabria" },
  { label: "Castilla-La Mancha", value: "Castilla-La Mancha" },
  { label: "Castilla y León", value: "Castilla y León" },
  { label: "Cataluña", value: "Cataluña" },
  { label: "Extremadura", value: "Extremadura" },
  { label: "Galicia", value: "Galicia" },
  { label: "Madrid", value: "Madrid" },
  { label: "Murcia", value: "Murcia" },
  { label: "Navarra", value: "Navarra" },
  { label: "La Rioja", value: "La Rioja" },
  { label: "País Vasco", value: "País Vasco" },
  { label: "Comunidad Valenciana", value: "Comunidad Valenciana" },
  { label: "Ceuta", value: "Ceuta" },
  { label: "Melilla", value: "Melilla" },
];
